import { createContext, Dispatch, useContext } from 'react';
import { TriggerEventAction } from './triggerEventActions';

export type TriggerEventContext = {
    events: TriggerEventAction['event'][];
};

type TriggerEventDispatchContext = Dispatch<TriggerEventAction>;

export const triggerEventContext = createContext<TriggerEventContext | null>(
    null
);

export const triggerEventDispatchContext = createContext<TriggerEventDispatchContext | null>(
    null
);

export const useTriggerEventContext = () => {
    const context = useContext(triggerEventContext);

    if (!context) {
        throw new Error(
            'useTriggerEventContext must be used within a TriggerEventProvider'
        );
    }

    return context;
};

export const useTriggerEventDispatchContext = () => {
    const context = useContext(triggerEventDispatchContext);

    if (!context) {
        throw new Error(
            'useTriggerEventDispatchContext must be used within a TriggerEventProvider'
        );
    }

    return context;
};
